import { render, staticRenderFns } from "./RecedeDetails.vue?vue&type=template&id=521bb332&"
import script from "./RecedeDetails.vue?vue&type=script&lang=js&"
export * from "./RecedeDetails.vue?vue&type=script&lang=js&"
import style0 from "./RecedeDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports